import Api from './api';

const ContratoService = {
    cadastro: async (params) => {
        const response = await Api.post('/restrito/contrato/cadastrar', params, {
            headers: { 'x-access-token': localStorage.getItem('token') }
        })
        return response
    },

    chamamento: async (params) => {
        const response = await Api.post('/restrito/contrato/chamamento', params, {
            headers: { 'x-access-token': localStorage.getItem('token') }
        })
        return response
    },

    listar: async () => {
        const response = await Api({
            method: 'get',
            url: '/restrito/contrato/listar',
            headers: { 'x-access-token': localStorage.getItem('token') }
        })
        return response
    },
    pegaLic: async (params) => {
        return Api({
            method: 'get',
            url: '/restrito/contrato/pegalic',
            params: params,
            headers: { 'x-access-token': localStorage.getItem('token') }
        })
    },
    deletar: (id) => {
        Api.delete(`/restrito/contrato/deletar/${id}`, {
            headers: { 'x-access-token': localStorage.getItem('token') }
        })
    },
    contratoEdit: async (id) => {
        const response = await Api.get(`/restrito/contrato/editar/${id}`,
            { headers: { 'x-access-token': localStorage.getItem('token') } })
        return response
    },
    editar: async (id, params) => {
        const response = await Api.put(`/restrito/contrato/editar/${id}`,
            params,
            { headers: { 'x-access-token': localStorage.getItem('token') } })
        return response
    },
    buscar: (params) => {
        const response = Api.get(`/restrito/contrato/buscar?${params}`,
            { headers: { 'x-access-token': localStorage.getItem('token') } })

        return response
    },
    termo: async (id, params) => {
        const response = await Api.put(`/restrito/contrato/termo/${id}`,
            params,
            { headers: { 'x-access-token': localStorage.getItem('token') } })
        return response
    }
}

export default ContratoService;